module.exports = __webpack_public_path__ + "845fc78927bea0b5467b4fa62a9f3d8d.pdf";